import { Link } from '@tanstack/react-router'

import { SimpleLogoPageContainer } from '@/components/shared/SimpleLogoPageContainer'
import { Box, Button, Stack, Text } from '@/components/ui'

export const NotFoundPage = () => {
  return (
    <SimpleLogoPageContainer centered showVersion={false}>
      <Stack gap="12" align="center">
        <Stack align="center" color="blue.600" fontWeight="semibold" gap="4">
          <Text fontSize="70px" lineHeight="1">
            404
          </Text>
          <Text>指定されたページが見つかりませんでした</Text>
        </Stack>
        <Box>
          <Link to="/trials">
            <Button as="span" variant="outline">
              トップページ
            </Button>
          </Link>
        </Box>
      </Stack>
    </SimpleLogoPageContainer>
  )
}
